import * as yup from "yup";
import { getEnumSchema } from "utils/schemas/utils";
import { BrandLayout, Module } from "__generated__/gql/graphql";
import { BRAND_LAYOUT_LABELS } from "components/Admin/Brands/Manage/BrandPanel/utils";
import { LABELS_BY_MODULE } from "components/Layout/BrandModuleAccessGate";
import { getIsAnalyticsLayoutDisabled } from "components/Layout/brandLayoutUtils";

export const name = yup.string().trim().label("Brand Name").required();

export const slug = yup
  .string()
  .min(3)
  .matches(
    /^[a-z0-9-]+$/,
    // eslint-disable-next-line no-template-curly-in-string
    "${label} must contain only lowercase letters, numbers and hyphens.",
  )
  .label("Brand Slug")
  .required();

export const website = yup
  .string()
  .trim()
  .label("Brand Website")
  .ensure()
  .default("")
  .notRequired()
  .url();

export const isInvalid = yup.bool().default(false).label("Invalid?");

export const isSubscriptionValid = yup
  .bool()
  .default(false)
  .label("Subscription Valid?");

export const isDataEntryEnabled = yup
  .bool()
  .default(false)
  .label("Data Entry Access Enabled?");

export const isParent = yup.bool().default(false).label("Parent?");

export const parentId = yup
  .string()
  .uuid()
  .nullable()
  .label("Parent")
  .when("isParent", {
    is: true,
    // eslint-disable-next-line no-template-curly-in-string
    then: (s) => s.is([null], "${label} cannot be set for parent brands."),
  });

export const brokerIds = yup
  .array()
  .of(yup.string().uuid())
  .ensure()
  .label("Brokers");

export const modules = yup
  .array()
  .of(getEnumSchema<Module>(Module))
  .ensure()
  .label("Modules");

export const layout = getEnumSchema<BrandLayout>(BrandLayout)
  .label("Layout")
  .when("modules", {
    is: (m: Module[] | undefined) => getIsAnalyticsLayoutDisabled(m),
    then: (s) =>
      s.test({
        name: "not-analytics",
        // eslint-disable-next-line no-template-curly-in-string
        message: `\${label} can only be set to “${
          BRAND_LAYOUT_LABELS[BrandLayout.ANALYTICS]
        }” if the “${
          LABELS_BY_MODULE[Module.ANALYTICS]
        }” module is the only module selected.`,
        test: (value) => value !== BrandLayout.ANALYTICS,
      }),
  });

export const isAnalyticsSyncEnabled = yup
  .bool()
  .default(false)
  .label("Sync analytics data to account?")
  .when("modules", {
    is: (m: Module[] | undefined) => !m?.includes(Module.ANALYTICS),
    then: (s) =>
      s.isFalse(
        `\${label} can only be enabled if the “${
          LABELS_BY_MODULE[Module.ANALYTICS]
        }” module is enabled.`,
      ),
  });
